export function Replace(el: any): any {
  const nativeElement: HTMLElement = el.nativeElement;
  const parentElement: HTMLElement|null = nativeElement.parentElement;
  // move all children out of the element
  while (nativeElement.firstChild) {
    if (parentElement !== null) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
  }
  // remove the empty element(the host)
  if (parentElement !== null) {
    parentElement.removeChild(nativeElement);
  }
}
